import { render, staticRenderFns } from "./book-layout.vue?vue&type=template&id=fe09bc52&scoped=true&"
import script from "./book-layout.vue?vue&type=script&lang=js&"
export * from "./book-layout.vue?vue&type=script&lang=js&"
import style0 from "./book-layout.vue?vue&type=style&index=0&id=fe09bc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe09bc52",
  null
  
)

export default component.exports